import config from '@/config'
import lib from '@/library'

export default {
  computed: {
    mediaServer () {
      var mediaHostName = config.app.autoconf.MEDIA_CONTENT_HOSTNAME

      mediaHostName = lib.core.url.prepareHostname(mediaHostName)

      return mediaHostName || '/static'
    },

    teamLogoHostname () {
      var path = config.app.teamLogoHostname

      path = lib.core.url.prepareHostname(path)

      return path || '/static'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Url.js